<template>
  <v-app v-bind:class="{ 'show-mobile' : $vuetify.breakpoint.smAndDown }">
    <v-main>
      <div class="main-bg"></div>
      <Home/>
    </v-main>
  </v-app>
</template>

<script>
import Home from './components/Home';

export default {
  name: 'App',

  components: {
    Home,
  },

  data: () => ({
  }),
  mounted() {
    this.$mixpanel.track('Session Start');
  },
  methods: {
  }
};
</script>
<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Do+Hyeon&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Jua&display=swap');
  @import './variables.scss';
  @import './animation.scss';

  @font-face{
    font-family:'NanumBarunGothic';
    src: url('assets/fonts/nanumbarungothic-webfont.woff') format('woff'),
        url('assets/fonts/nanumbarungothic-webfont.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
  }
  @font-face{
    font-family:'NanumBarunGothic';
    src: url('assets/fonts/nanumbarungothicbold-webfont.woff') format('woff'),
    url('assets/fonts/nanumbarungothicbold-webfont.woff2') format('woff2');
    font-weight: bold;
    font-style: normal;
  }

  /* GO Main Styles*/
  html, body {
    overflow: hidden !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  ul {
    list-style: none;
  }

  p {
    margin: 0;
  }
  .swiper-wrapper {
    height: 100% !important;
    flex-direction: row !important;
    display: flex !important;
  }
  #app {
    position: fixed;
    height: 100%;
    width: 100%;
    background: white;
    padding: 0;
    .v-application--wrap {
      min-height: 100% !important;
    }
    main {
      width: 100%;
      height: 100%;
      background: $defaultBackgroundColor;
    }
    .main-bg {
      position: absolute;
      width: 100%;
      height: 40%;
      background: $softBlueColor;
      right: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      border-top: 1px solid #ececec;
    }
    .main-bg.endAni {
      width: 55%;
      height: 100%;
      top: 0;
      right: 0;
      left: unset;
      bottom: 0;
      margin: auto;
      border-left: 1px solid #ececec;
    }
  }
  #app.show-mobile {
    font-size: 12px;

  }
</style>
